import { render, staticRenderFns } from "./OnboardingWizardIdeaCover.vue?vue&type=template&id=3a0c951e&scoped=true"
import script from "./OnboardingWizardIdeaCover.vue?vue&type=script&lang=js"
export * from "./OnboardingWizardIdeaCover.vue?vue&type=script&lang=js"
import style0 from "./OnboardingWizardIdeaCover.vue?vue&type=style&index=0&id=3a0c951e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c951e",
  null
  
)

export default component.exports